import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../Components/Layout/Layout';
import DishesList from '../Components/Dishes/DishesList';
import { Button } from "@/Components/ui/button";
import { Plus } from "lucide-react";
import { ChevronRight, QrCode } from "lucide-react";
import axiosInstance from '../utils/axiosConfig';
import GoogleTranslate from '../Components/Layout/GoogleTranslate'; 
import TranslatableImage from '../Components/Layout/TranslatableImage'; 

import icon1 from '../images/allergens/1.webp';
import icon3 from '../images/allergens/3.webp';
import icon4 from '../images/allergens/4.webp';
import icon5 from '../images/allergens/5.webp';
import icon11 from '../images/allergens/11.webp';
import icon12 from '../images/allergens/12.webp';
import icon16 from '../images/allergens/16.webp';
import icon17 from '../images/allergens/17.webp';
import icon19 from '../images/allergens/19.webp';
import icon21 from '../images/allergens/21.webp';
import icon22 from '../images/allergens/22.webp';
import icon23 from '../images/allergens/23.webp';
import icon24 from '../images/allergens/24.webp';
import icon26 from '../images/allergens/26.webp';
import empty from '../images/allergens/empty.png';

import icon1b from '../images/dieets/1.png';
import icon2b from '../images/dieets/2.png';
import icon3b from '../images/dieets/3.png';
import icon4b from '../images/dieets/4.png';
import icon5b from '../images/dieets/5.png';
import icon6b from '../images/dieets/6.png';
import icon7b from '../images/dieets/7.png';
import icon8b from '../images/dieets/8.png';
import icon9b from '../images/dieets/9.png';
import icon10b from '../images/dieets/10.png';


const allergenIcons = {
    1: icon1,
    3: icon3,
    4: icon4,
    5: icon5,
    11: icon11,
    12: icon12,
    16: icon16,
    17: icon17,
    19: icon19,
    21: icon21,
    22: icon22,
    23: icon23,
    24: icon24,
    26: icon26,
};
const dietaryIcons = {
    1: icon1b,
    2: icon2b,
    3: icon3b,
    4: icon4b,
    5: icon5b,
    6: icon6b,
    7: icon7b,
    8: icon8b,
    9: icon9b,
    10: icon10b
};

const Result = () => {
    const { token } = useParams();
    const [categories, setCategories] = useState([]);

    const [data, setData] = useState({
        name: '',
        categories: [],
        price: false,
        diets: false,
        allergens: false,
        translate: false,
        font: '',
        backgroundcolor: '',
        textcolor: '',
        logo: '',
        currency: '�'
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null); 


    useEffect(() => {
        document.body.style.backgroundColor = data.backgroundcolor || '#ffffff';
        document.body.style.color = data.textcolor || '#000000';
        document.body.style.fontFamily = data.font || 'system-ui';
        return () => {
            document.body.style.backgroundColor = '#ffffff';
            document.body.style.color = '#000000';
            document.body.style.fontFamily = 'system-ui';
        };
    }, [data.backgroundcolor]);

    useEffect(() => {
        const fetchDishes = async () => {
            try {
                setIsLoading(true);
                const response = await axiosInstance.get(`/menu/GetCompleteMenu/${token}`);
                const data = await response.data;

                if (response.data.font) {
                    const link = document.createElement('link');
                    link.href = `https://fonts.googleapis.com/css2?family=${response.data.font.replace(' ', '+')}:wght@300;400;700&display=swap`;
                    link.rel = 'stylesheet';
                    document.head.appendChild(link);
                }

                try {
                    setData(data);
                    setCategories(data.categories);
                } catch (e) {
                    console.error('Unexpected API response format:', data);
                    setCategories([]);
                }
            } catch (error) {
                console.error('Error fetching dishes:', error);
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };
        fetchDishes();
    }, []);


    if (isLoading) return <><div>Loading...</div></>;
    if (error) return <><div>Error: {error}</div></>;

    return ( 
        <div className="flex justify-center items-center menucard">
            <div className="h-full max-w-screen-lg flex-1" >
            <div className="p-2">
                {data.logo && (
                    <div className="mb-6 flex justify-center">
                        <img
                            src={`${import.meta.env.VITE_APIURL}menu/GetImage/${token}`}
                            alt={data.CompanyName}
                            className="max-h-32 w-auto"
                        />
                    </div>
                )}

                <div className="header">
                    {data.translate && <GoogleTranslate />}
                </div>

                <div className="text-4xl mb-8">{data.name}</div>

                <div className="relative">
                    <div className="space-y-8">
                        {Array.isArray(categories) && categories.length > 0 ? (
                            categories.some(category => category?.dishes?.length > 0) ? (
                                categories.map((category) => (
                                    category?.dishes?.length > 0 && category?.name && (
                                        <div key={category.id || `category-${Math.random()}`} className="mb-4">
                                            <h3 className="text-xl mb-0 mt-4 font-bold">
                                                {category.name}
                                            </h3>
                                            {category.description !== '' && (
                                            <span className="font-light">
                                                {category.description}
                                            </span>
                                            )}
                                            <div className="space-y-2 mt-2">
                                                {category.dishes.map((dish) => (
                                                    <div key={dish.id || `dish-${Math.random()}`}>
                                                        <div className="flex items-center justify-between w-full p-4 pb-0">
                                                            <span className="font-bold text-lg">
                                                                {dish.name}
                                                            </span>
                                                            <div className="flex items-center gap-6">
                                                                {data.price && (
                                                                    <div className="flex text-base">
                                                                        <span className="mr-1">{data.currency}</span>
                                                                        <span className="w-12 text-right">
                                                                            {(dish.price || 0).toFixed(2)}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="w-full pl-4 pb-0">
                                                            <span className="font-extralight text-lg">
                                                                {dish.description}
                                                            </span>
                                                        </div>
                                                        {(data.allergens && dish.allergens && dish.allergens.length > 0) && (
                                                            <div className="w-full pl-4">
                                                                <div className="flex items-center gap-2">
                                                                    <span className="font-extralight text-sm">Allergen</span>
                                                                    {dish.allergens
                                                                        .filter(allergen => allergenIcons[allergen.id])
                                                                        .map((allergen) => (
                                                                            <div key={allergen.id} className="inline-flex items-center">
                                                                                <TranslatableImage
                                                                                    name={allergen.name}
                                                                                    iconSrc={allergenIcons[allergen.id]}
                                                                                />
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(data.diets && dish.dietaryneeds && dish.dietaryneeds.length > 0) && (
                                                            <div className="w-full pl-4">
                                                                <div className="flex items-center gap-2">
                                                                    <span className="font-extralight text-sm">Dieet wensen</span>
                                                                    {dish.dietaryneeds
                                                                        .filter(dietaryneed => dietaryIcons[dietaryneed.id])
                                                                        .map((dietaryneed) => (
                                                                            <div key={dietaryneed.id} className="inline-flex items-center">
                                                                                <TranslatableImage
                                                                                    name={dietaryneed.name}
                                                                                    iconSrc={dietaryIcons[dietaryneed.id]}
                                                                                />
                                                                            </div>
                                                                        ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="w-full pl-3 pb-3">
                                                            <span className="font-extralight text-xs"></span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )
                                ))
                            ) : (
                                <div className="text-center py-8">
                                    Er zijn geen kaarten gevonden
                                </div>
                            )
                        ) : (
                            <div className="text-center py-8">
                                Er zijn geen kaarten gevonden
                            </div>
                        )}
                    </div>
                </div>
            </div>
                </div>
            </div> 
    );
};

export default Result;